import { ProfileFollowApi } from 'api/ApiHelper';
import { profileFollowQueryKey } from 'queries/profileFollow/queryKey';
import { useQuery } from '@tanstack/react-query';

export const useGetFollowProfileQuery = (profileId: number) =>
  useQuery({
    queryKey: profileFollowQueryKey.profileFollow(profileId),
    queryFn: () => ProfileFollowApi.getFollowProfile(profileId),
  });
